// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Y4xo","title":"InfoRow_title__1LHro"};